/* PawlyBuddy FAQ Accordion */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pb-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.pb-faq-item');
      const isOpen = item.classList.contains('open');
      /* Close all in same column */
      const col = item.closest('.pb-faq-col, .pb-faq-cols');
      if (col) col.querySelectorAll('.pb-faq-item.open').forEach(function(i){ i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
  /* Open default */
  const def = document.querySelector('.pb-faq-item[data-default-open]');
  if (def) def.classList.add('open');
});
